import { ThunkType } from "../../../../../core/store/reducers";
import { getWeightedPriceExcel } from "../api/getWeightedPriceExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../weightedPriceDataSlice";

export const downloadWeightedPricesExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.weightedPrice;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getWeightedPriceExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "WeightedPrice.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
